import * as React from "react";
import KodaIcon from "./KodaIcon";

/** Koda mirrored + slightly rotated — used for the "Health Trends" walkthrough step. */
const KodaPointing = (props: React.SVGProps<SVGSVGElement>) => (
  <KodaIcon
    {...props}
    style={{
      ...props.style,
      transform: "scaleX(-1) rotate(-6deg)",
      transformOrigin: "center bottom",
    }}
  />
);

export default KodaPointing;
